import styled from 'styled-components';

export const ContainerScreens = styled.div`
  width: 100%;
  height: 100%;
  padding: 5px;
`;

export const ButtonItens = styled.button`
  display: flex;
  background: none;
  border: none;
  gap: 5px;
  align-items: center;
  height: 40px;
  padding: 10px;
  margin-top: 10px;
  svg {
    font-size: 16pt;
  }
  span {
    color: rgb(107, 119, 140);
  }
  &:hover {
    border: #4c9aff;
  }
  &:disabled {
    cursor: not-allowed;
  }
`;

export const ContainerTotal = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: flex-end;
  height: 40px;
  padding: 10px;
  margin-top: 10px;
  span {
    font-weight: 600;
    color: rgb(107, 119, 140);
  }
`;
